<script>

    import {getContext} from "svelte";
    import LoginContentComponent from "./LoginContentComponent.svelte";

    const { open } = getContext('simple-modal');

    export let model_root;

    open(LoginContentComponent, {
        model_root: model_root
    }, {
        closeButton: false,
        closeOnEsc: true,
        closeOnOuterClick: false,
        transitionBgProps: {
            duration: 0
        },
        styleBg: { background: '#073c49' },
        styleWindow: { background: '#ffffff', padding: '10px' },
    }, {
        onClosed: () => {  }
    });

</script>

